import React from 'react'
import {ExternalLink} from 'lucide-react'

interface ComparisonRow {
  provider: string
  price: string
  features: string[]
  ctaText: string
  ctaLink: string
  highlight?: boolean
}

interface ComparisonTableProps {
  title: string
  rows: ComparisonRow[]
}

const ComparisonTable: React.FC<ComparisonTableProps> = ({ title, rows }) => {
  return (
    <div className="my-12">
      <h3 className="text-2xl font-bold text-gray-900 mb-6">{title}</h3>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse bg-white shadow-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Provider</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Price</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Features</th>
              <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr 
                key={index}
                className={`border-t border-gray-200 ${row.highlight ? 'bg-red-50' : ''}`}
              >
                <td className="px-6 py-4">
                  <span className="font-medium text-gray-900">{row.provider}</span>
                  {row.highlight && (
                    <span className="ml-2 inline-block px-2 py-1 text-xs font-semibold text-white bg-red-600 rounded">
                      Best Value
                    </span>
                  )}
                </td>
                <td className="px-6 py-4 text-gray-700 font-semibold">{row.price}</td>
                <td className="px-6 py-4">
                  <ul className="text-sm text-gray-600 space-y-1">
                    {row.features.map((feature, idx) => (
                      <li key={idx}>• {feature}</li>
                    ))}
                  </ul>
                </td>
                <td className="px-6 py-4 text-center">
                  <a
                    href={row.ctaLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-red-600 text-white text-sm font-semibold rounded hover:bg-red-700 transition-colors"
                  >
                    {row.ctaText}
                    <ExternalLink size={16} className="ml-2" />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ComparisonTable
